import React, { lazy, Suspense, useMemo } from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import AppHOC from "../../../generics/AppHOC";
import Spinner from "../../../common/Spinner";
import PredictiveNetworksTabs from "../PredictiveNetworksTabs";
import FeatureDisabled from "../../../generics/authorization/FeatureDisabled";
import { isBandForecastingTabSelected } from "../../../utils/common";
import { getBWFAccess } from "../../../utils/license";
import { MFE_COMPONENT_IDS } from "../../../utils/enums";
import { getCookie } from "../../../serviceWorker";
import UnifyMFEWidgetRenderer from "../../../generics/mfe/UnifyMFEWidgetRenderer";
import MFEUnavailableState from "../../../generics/mfe/MFEUnavailableState";
import css from "../insightsMagneticStyle.less";

const [HbrCard] = reactWrapper(["hbr-card"]);
const OnboardingView = lazy(() => import("./OnboardingView"));

const PredictiveWidgetTop = (props) => {
  const bwfAccess = useMemo(() => getBWFAccess(), []);
  const first20CharsUrl = location.href.substring(0, 20);
  //check if au region
  const isPredictivLabelEnabled = first20CharsUrl.includes("au");
  const { predictiveTabSelected } = isPredictivLabelEnabled
    ? { predictiveTabSelected: "bandForecastingTab" }
    : props.globalFilter;
  const isBF = isBandForecastingTabSelected();
  const isUIConvergence = getCookie("cl-analytics");
  const shouldShowBandwidthForecast =
    bwfAccess.available === true &&
    (predictiveTabSelected === "bandForecastingTab" || isBF);

  switch (true) {
    case shouldShowBandwidthForecast: {
      return (
        <Suspense fallback={<Spinner />}>
          <HbrCard
            className={`${css["bandwidth-forecasting-widget"]}`}
            id="bandwidth-forecast-card"
            container
          >
            {!isUIConvergence && <PredictiveNetworksTabs />}
            {bwfAccess.available === true ? (
              bwfAccess.enabled === true ? (
                <UnifyMFEWidgetRenderer
                  componentId={MFE_COMPONENT_IDS.BANDWIDTH_FORECAST}
                  errorComponent={(
                    <MFEUnavailableState
                      componentId={MFE_COMPONENT_IDS.BANDWIDTH_FORECAST}
                      display="full"
                    />
                  )}
                />
              ) : (
                <FeatureDisabled />
              )
            ) : null}
          </HbrCard>
        </Suspense>
      );
    }
    case (predictiveTabSelected === "pprTab" ||
      predictiveTabSelected === "anomalyTab") &&
      !isPredictivLabelEnabled: {
      return (
        <Suspense fallback={<Spinner />}>
          <OnboardingView />
        </Suspense>
      );
    }
    default:
      return null;
  }
};

PredictiveWidgetTop.propTypes = {
  globalFilter: PropTypes.object,
};

export default AppHOC(PredictiveWidgetTop);
